import { notification } from "antd";
import {
  getExamGroupSuccess,
  getExamGroupsSuccess,
} from "features/examGroupSlice";
import queryString from "query-string";
import { call, all, put, takeLatest } from "redux-saga/effects";
import { getClassrooms } from "sagas/classroomSaga";
import { getRoles } from "sagas/roleSaga";
import { DELETE, GET, PATCH, POST, PUT } from "services/ServiceBase";
import ServiceURL from "services/ServiceURL";
import { ActionType } from "type";
var _ = require("lodash");
export function* getExamGroups(data: ActionType): any {
  const { callback, body, query, skipUpdateReducer } = data.payload;
  const url = `${ServiceURL.examgroup}?${query ?? ""}`;
  try {
    const res = yield call(GET, url, body);
    if (!!res.data?.error?.message) {
      callback.failed(res.data?.error?.message);
    } else {
      if (!skipUpdateReducer)
        yield put(getExamGroupsSuccess(_.get(res, "data", [])));
      callback.success(_.get(res, "data", []));
    }
  } catch (error: any) {
    callback.failed(error?.message ?? "");
  }
}
export function* getExamGroup(data: ActionType): any {
  const { callback, body, query, params } = data.payload;
  const url = `${ServiceURL.examgroup}/${params}?${query ?? ""}`;
  try {
    const res = yield call(GET, url, body);
    if (!!res.data?.error?.message) {
      callback.failed(res.data?.error?.message);
    } else {
      yield put(getExamGroupSuccess(_.get(res, "data", {})));
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    let err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}
export function* createExamGroup(data: ActionType): any {
  const { callback, body } = data.payload;
  const url = ServiceURL.examgroup;
  try {
    const res = yield call(POST, url, body);
    if (!!res?.response?.data?.code && !!res?.response?.data?.message) {
      callback.failed(res?.response?.data?.message);
    } else {
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    let err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}
export function* updateExamGroup(data: ActionType): any {
  const { callback, body, params } = data.payload;
  const url = `${ServiceURL.examgroup}/${params}`;
  try {
    const res = yield call(PATCH, url, body);
    if (!!res?.response?.data?.code && !!res?.response?.data?.message) {
      callback.failed(res?.response?.data?.message);
    } else {
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    let err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}
export function* deleteExamGroup(data: ActionType): any {
  const { callback, body, params } = data.payload;
  const url = `${ServiceURL.examgroup}/${params}`;
  try {
    const res = yield call(DELETE, url, body);
    if (!!res.data?.error?.message) {
      callback.failed(res.data?.error?.message);
    } else {
      callback.success(res);
    }
  } catch (error: any) {
    let err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}
export default function* examGroupSaga() {
  yield takeLatest("examGroupSlice/getExamGroups", getExamGroups);
  yield takeLatest("examGroupSlice/getExamGroup", getExamGroup);
  yield takeLatest("examGroupSlice/createExamGroup", createExamGroup);
  yield takeLatest("examGroupSlice/updateExamGroup", updateExamGroup);
  yield takeLatest("examGroupSlice/deleteExamGroup", deleteExamGroup);
}
